import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IStepCardProps {
  number: React.ReactText;
}

export const StepCard: React.FC<React.PropsWithChildren<IStepCardProps>> = ({ number, children }) => {
  return (
    <div className={styles['container']}>
      <span className={styles['number']}>{number}</span>
      <InlineText1>{children}</InlineText1>
    </div>
  );
};

StepCard.displayName = 'StepCard';
